import React from 'react'
import { NoFilterResults } from 'src/components/PageLayout/NoFilterResults'
import { TableListLoader } from 'src/components/Reusable/ContentLoaders/TableListLoader'
import { Service } from 'src/xgenerated/service'
import { ServicesGrid } from '../grid/ServicesGrid'
import { AddServicesModal } from '../modals/AddServicesModal'
import { AddServiceRolesModal } from '../modals/AddServiceRolesModal'
import { ServicesProvider } from '../context/ServicesContext'
import { CreateCustomServiceModal } from '../modals/CreateCustomServiceModal'

export const ServicesIndexGrid = ({
  services,
  isLoading,
}: {
  services: Service[]
  isLoading: boolean
}): JSX.Element => {
  if (isLoading) {
    return <TableListLoader />
  }

  return (
    <>
      {services.length > 0 ? (
        <ServicesGrid services={services} />
      ) : (
        <NoFilterResults />
      )}
      <ServicesProvider>
        <AddServicesModal />
        <AddServiceRolesModal />
        <CreateCustomServiceModal />
      </ServicesProvider>
    </>
  )
}
